import { useDeploymentStore } from '@/store/deploymentStore';
import { CognitoService } from '@/auth/CognitoService';
import { publishWebApp } from './publishWebApp';

/**
 * Publishes through the configured backend, resolving the base URL and access token the
 * same way `buildsClient` does. Split from `publishWebApp` so the publishing logic stays
 * a pure function of its dependencies and remains testable without stores or auth.
 */
export async function publishViaBackend(html: string, appId: string): Promise<{ url: string }> {
  const baseUrl = (useDeploymentStore.getState().config?.apiBaseUrl ?? '').replace(/\/+$/, '');
  const result = await publishWebApp(html, {
    appId,
    baseUrl,
    getToken: () => CognitoService.getAccessTokenSync(),
  });
  return { url: result.url };
}
